var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.492 1.66666H6.50866C3.83468 1.66666 1.66699 3.83434 1.66699 6.50832V13.4917C1.66699 16.1656 3.83468 18.3333 6.50866 18.3333H13.492C16.166 18.3333 18.3337 16.1656 18.3337 13.4917V6.50832C18.3337 3.83434 16.166 1.66666 13.492 1.66666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6099 6.20505C14.8838 6.47844 14.8838 6.92243 14.6099 7.19583L9.0018 12.795C8.72797 13.0683 8.28326 13.0683 8.00943 12.795L5.20538 9.99539C4.93154 9.722 4.93154 9.278 5.20538 9.00461C5.47921 8.73121 5.92391 8.73121 6.19775 9.00461L8.50671 11.3077L13.6197 6.20505C13.8936 5.93165 14.3383 5.93165 14.6121 6.20505H14.6099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.a90cb9891fe9b6297fb94884d36c3599.svg";
export { ForwardRef as ReactComponent };